import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M14.466 12.037h-7.22M10 7.86H7.246M18.165 9V7.357c0-2.784-1.723-4.607-4.507-4.607l-6.689.004C4.209 2.771 2.5 4.587 2.5 7.357v9.196c0 2.784 1.722 4.607 4.506 4.607l6.689-.003c.721-.004 1.37-.132 1.937-.367M21.641 16.085H7.284M18.713 19l2.928-2.915-2.928-2.916"
    }, null, -1)
  ]))]))
}
export default { render: render }